import { Disclosure, Transition } from '@headlessui/react';
import React from 'react';

import cn from 'classnames';
import dropdownIcon from 'students/views/shared/assets/icons/dropdown_icon.svg';
import styled from 'styled-components';
import { buttonStylesReset } from '../../styled';
import UrlIcon from '../UrlIcon';

type tProps = {
  triggerButtonContentOnOpen: React.ReactElement;
  triggerButtonContentOnClose: React.ReactElement;
  renderItems: () => React.ReactElement;
  className?: string;
  disabled?: boolean;
  iconColor?: string;
};
const Collapsible: React.FC<tProps> = ({
  triggerButtonContentOnOpen,
  triggerButtonContentOnClose,
  renderItems,
  disabled,
  className,
  iconColor
}) => {
  return (
    <Disclosure as={SDisclosure}>
      {({ open }) => (
        <>
          <Disclosure.Button
            className={cn(
              'collapsible_button',
              { 'collapsible_button--open': open },
              className
            )}
            disabled={disabled}
          >
            {open ? triggerButtonContentOnOpen : triggerButtonContentOnClose}
            {disabled ? null : (
              <SUrlIcon
                url={dropdownIcon}
                color={iconColor}
                className={cn({ open })}
                width="12px"
                height="12px"
              />
            )}
          </Disclosure.Button>
          <Transition
            enter="collapsible-panel"
            enterFrom="collapsible-panel--from"
            enterTo="collapsible-panel--to"
          >
            <Disclosure.Panel>{renderItems()}</Disclosure.Panel>
          </Transition>
        </>
      )}
    </Disclosure>
  );
};

export default Collapsible;

const SDisclosure = styled.div`
  & .collapsible-panel {
    transition: max-height 1s, opacity 0.3s, scale 0.3s;
    transform-origin: top left;
    overflow: hidden;
  }
  & .collapsible-panel--from {
    transform: scale(0.9);
    opacity: 0;
    max-height: 0;
  }
  & .collapsible-panel--to {
    transform: scale(1);
    opacity: 1;
    max-height: 2000px; //note that this 2000px affects max-height transition speed
  }

  & .collapsible_button {
    ${buttonStylesReset}
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-inline-start: 0;
    padding-inline-end: 0;
    transition: opacity 0.3s;
  }

  & .collapsible_button--open {
    opacity: 0.7;
  }
`;

const SUrlIcon = styled(UrlIcon)`
  &.open {
    transform: rotate(180deg);
  }
`;
